import { publicEnv } from "@/lib/env/public";

export const DEFAULT_DATADOG_SITE = "us3.datadoghq.com";

// The one read of the Datadog site: RUM and every deep link share it.
export function datadogSite(): string {
  return publicEnv("DATADOG_SITE") ?? DEFAULT_DATADOG_SITE;
}

export function datadogTraceUrl(traceHex: string): string {
  return `https://${datadogSite()}/apm/trace/${traceHex}`;
}
